import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-close-red",
  "use": "default-close-red-usage",
  "viewBox": "0 0 23 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 23\" id=\"default-close-red\"><path fill=\"#e3000f\" d=\"M22.145.5l1.9 1.9-9.098 9.1 9.098 9.1-1.9 1.9-9.439-9.439L3.267 22.5l-1.9-1.9 9.099-9.1-9.099-9.1 1.9-1.9 9.439 9.439L22.146.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol